<script>
    import { createEventDispatcher } from "svelte";
    import { fly, fade } from "svelte/transition";
    import Logo from "../Logo.svelte";
    import { push } from "svelte-spa-router";
    import { _, locale } from "svelte-i18n";
    import { getLocale } from "../../util/locale";

    let openMenu = true;

    let dispatch = createEventDispatcher();
    export let flyAnimation;

    const locales = [
        {
            locale: "de",
            name: "Deutsch",
        },
        {
            locale: "fr",
            name: "Français",
        },
        {
            locale: "en",
            name: "English",
        },
    ];

    function closeClicked() {
        dispatch("closeClicked");
        openMenu = false;
    }
</script>

<div
    class="menu blur"
    in:fade={{ y: 812, duration: flyAnimation, opacity: 1 }}
    out:fade={!openMenu
        ? { y: 812, duration: flyAnimation, opacity: 1 }
        : { y: 0, duration: 1, opacity: 1 }}
>
    <div class="menu-wrapper">
        <div class="menu-left disp-big" />
        <div class="divider-v disp-big" />
        <div class="menu-right">
            <div style="display:flex; justify-content:right; height:76px;">
                <img
                    src="/images/icons/close.svg"
                    alt={$_("close")}
                    class="close"
                    on:click={closeClicked}
                    width="32"
                    height="32"
                />
            </div>
            <div class="menu-rows">
                {#each locales as item, index}
                    <div
                        class="headline-m locale"
                        class:selected={item.locale === getLocale()}
                        on:click={() => {
                            $locale = item.locale;
                            window.localStorage.setItem("locale", item.locale);
                            closeClicked();
                        }}
                    >
                        {item.name}
                    </div>
                    {#if index < locales.length - 1}
                        <div class="divider-h" style="margin: 24px 0;" />
                    {/if}
                {/each}
                <div class="text-l bottom-text">Choose your language</div>
            </div>
        </div>
    </div>
</div>

<style>
    .menu-wrapper {
        height: 100vh;
        width: 100vw;
        /*background: var(--white-64);*/
        -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
        -moz-box-sizing: border-box; /* Firefox, other Gecko */
        box-sizing: border-box;
    }

    .menu-rows {
        padding-bottom: 41px;
        padding-top: 42px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        margin-left: 16px;
        margin-right: 16px;
    }

    .menu {
        position: fixed;
        z-index: 2;
    }

    .close {
        margin: 24px 24px 0 0;
    }

    .disp-big {
        display: none;
    }

    .blur {
        -webkit-backdrop-filter: blur(24px);
        backdrop-filter: blur(24px);
        background: var(--white-64);
    }

    .bottom-text {
        margin-top: 48px;
    }

    .locale {
        color: var(--black-40);
    }

    .selected {
        color: var(--black-100);
    }

    @media only screen and (min-width: 799px) {
        .menu-wrapper {
            display: flex;
            flex-direction: row;
        }

        .menu-rows {
            padding-right: 40px;
            padding-left: 40px;
        }

        .menu-left {
            display: flex;
            flex-direction: column;
            flex-basis: 58%;
        }

        .menu-right {
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            -webkit-backdrop-filter: blur(24px);
            backdrop-filter: blur(24px);
            background: var(--white-64);
        }

        .close {
            margin: 23px 28px 0 0;
        }

        .disp-small {
            display: none;
        }

        .disp-big {
            display: flex;
        }

        .blur {
            -webkit-backdrop-filter: unset;
            backdrop-filter: unset;
            background: unset;
        }
    }
</style>
